exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 768px) {\n.mobile[data-v-0985f32e] {\n    display: none;\n}\n.adori-logo[data-v-0985f32e] {\n    display: none;\n}\n}\n", ""]);

// exports
